/* eslint-disable max-lines */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable indent */
/* eslint-disable max-len, complexity */
import AddToCart from "./AddToCart";
import Helper from "../../../shared/modules/Helper";
import {Link} from "react-router-dom";
import MemberDiscountHelper from "../../../shared/modules/MemberDiscountHelper";
import ProductDescriptorViewsAPI from "../../../shared/modules/ProductDescriptorViewsAPI";
import ProductPanelImageOrCarousel from "../components/ProductPanelImageOrCarousel";
import ProductRating from "../../../shared/components/ProductRating";
import PromoPriceVariantHelper from "../../../shared/modules/PromoPriceVariantHelper";
import PropTypes from "prop-types";
import React from "react";
import RingSizeSelection from "../components/RingSizeSelection";
import SharedPropTypes from "../../Swap/modules/SharedPropTypes";
import Star from "../../../shared/components/Star";
import SwapButton from "../../Swap/components/SwapButton";
import {connect} from "react-redux";
import {isMobile} from "../../../lib/userAgent.js";
import {withCookies} from "react-cookie";

class ProductPanel extends React.Component {

  static propTypes = {
    "addToCartFromGrid": PropTypes.bool,
    "addWishListRequest": PropTypes.func.isRequired,
    "allRingSizes": PropTypes.array.isRequired,
    "cookies": PropTypes.object.isRequired,
    "customerId": PropTypes.string,
    "customerRequests": PropTypes.object.isRequired,
    "eligibleForFineJewelry": PropTypes.bool.isRequired,
    "handleShowSwapModal": PropTypes.func,
    "isLoggedOutHomepage": PropTypes.bool.isRequired,
    "onSelectSwap": PropTypes.func,
    "pdPrices": PropTypes.object,
    "previewSwapping": PropTypes.bool,
    "productDescriptor": PropTypes.object.isRequired,
    "productDescriptors": SharedPropTypes.productDescriptors,
    "productPanelClass": PropTypes.string,
    "removeWishListRequest": PropTypes.func.isRequired,
    "ringSizes": PropTypes.array,
    "setNotificationType": PropTypes.func.isRequired,
    "showClearancePrice": PropTypes.bool.isRequired,
    "showComingSoon": PropTypes.bool.isRequired,
    "showModal": PropTypes.func.isRequired,
    "showProductName": PropTypes.bool.isRequired,
    "showRetailPrice": PropTypes.bool.isRequired,
    "showTags": PropTypes.bool.isRequired,
    "showWishlistStars": PropTypes.bool.isRequired,
    "useModal": PropTypes.bool.isRequired,
    "wishlisted": PropTypes.bool.isRequired
  };

  static defaultProps = {
    "addToCartFromGrid": false,
    "customerId": "",
    "customerRequests": {},
    "eligibleForFineJewelry": false,
    "handleShowSwapModal": null,
    "isLoggedOutHomepage": false,
    "onSelectSwap": null,
    "pdPrices": {},
    "previewSwapping": false,
    "productDescriptors": null,
    "productPanelClass": "",
    "ringSizes": []
  };

  static queryParamBuilder = (currentQuery, newQuery) => {
    if (!newQuery || newQuery.length === 0) return currentQuery;

    return (/^\?/).test(currentQuery) ? `${currentQuery}&${newQuery}` : `?${newQuery}`;
  }

  constructor (props) {
    super(props);
    this.defaultImageUrl = "/assets/roxy/veto_swap/fallback-image";

    const {addToCartFromGrid, productDescriptor, showClearancePrice} = this.props;
    const {"details": {"kind_name": kindName, swatches}} = productDescriptor;

    this.state = {
      "availableSwatches": swatches.filter(swatch => swatch.available.filter(item => (showClearancePrice ? item.available_clearance_count : item.available_retail_count) > 0)),
      "enableAddToCart": addToCartFromGrid && (Helper.inExperimentVariant("add_to_cart_from_grid_var_a") || Helper.inExperimentVariant("add_to_cart_from_grid_var_b")),
      "hoveredSwatchId": null,
      "isRing": kindName === "Ring",
      "omitQuickView": addToCartFromGrid && Helper.inExperimentVariant("add_to_cart_from_grid_var_b"),
      "selectedRingSize": null,
      "selectedSwatchId": null,
      "showQuickViewButton": false,
      "showingRingSelection": false
    };
  }

  setHoveredSwatchId = (swatchId) => {
    this.setState({"hoveredSwatchId": swatchId});
  }

  setNotificationType = (value) => {
    const {setNotificationType} = this.props;
    setNotificationType(value);
  }

  setSelectedRingSize = (size) => {
    this.setState({"selectedRingSize": size});
  }

  setSelectedSwatchId = (swatchId) => {
    this.setState({"selectedSwatchId": swatchId});
  }

  checkTag = (tag) => {
    if (tag === "Demi-Fine") return "demifine";
    if (tag === "Fine Jewelry") return "fine";
    return "";
  }

  isSwapped = () => {
    const {productDescriptor, productDescriptors} = this.props;
    for (const key in productDescriptors) {
      if (productDescriptors[key].id === productDescriptor.id) return true;
    }
    return false;
  }

  updateWishListRequests = (state) => {
    const {addWishListRequest, "productDescriptor": {originalId}, removeWishListRequest} = this.props;
    Object.values(state).forEach((value) => {
      const {id, wishlisted} = value;
      if (wishlisted) {
        addWishListRequest(id, id !== originalId);
      } else {
        removeWishListRequest(id, id !== originalId);
      }
    });
  };

  handleClick = (event) => {
    const {previewSwapping} = this.props;

    if (previewSwapping) {
      this.showModal(event);
    }
  }

  handleHideRingSizeWishList = () => this.setState({"showingRingSelection": false});

  handleShowRingSizeWishList = () => this.setState({"showingRingSelection": true});

  handleHideQuickViewButton = () => {
    if (isMobile()) return;
    this.setState({"showQuickViewButton": false});
  }

  handleShowQuickViewButton = () => {
    if (isMobile()) return;
    this.setState({"showQuickViewButton": true});
  }

  sendQuickViewEvent = () => {
    const {"productDescriptor": {id}} = this.props;

    ProductDescriptorViewsAPI.createProductDescriptorView(id, "quick_view");
  }

  showModal = (event) => {
    const {"productDescriptor": {id}, showModal} = this.props;
    event.preventDefault();
    this.sendQuickViewEvent();
    showModal(id);
  };

  displayWishlistStar = (kindName, wishlisted) => {
    const {ringSizes} = this.props;
    if (kindName === "Ring") {
      return ringSizes.filter(ring => ring.wishlisted).length > 0;
    }
    return wishlisted;
  }

  shouldDisplaySlider = () => {
    const {productDescriptor} = this.props;
    const {"details": {"thumbnail_urls": thumbnailImages}} = productDescriptor;

    return thumbnailImages.length > 1 && isMobile();
  }

  getClearancePrice = () => {
    const {
      customerId,
      pdPrices,
      productDescriptor
    } = this.props;
    const {
      "details": {"clearance_price": noCustomerClearancePrice},
      id
    } = productDescriptor;

    const isCustomerPresent = customerId && customerId.length;
    const isClearancePriceAvailable = pdPrices[id] && pdPrices[id].clearance_price;

    if (isCustomerPresent && isClearancePriceAvailable) {
      return pdPrices[id].clearance_price;
    }

    return noCustomerClearancePrice;
  }

  getPromoPriceInfo = () => {
    const {cookies, "productDescriptor": {"promo_price_info": promoPriceInfo}} = this.props;
    const autoAppliedPromoCode = cookies.get("auto_applied_promo_code");

    return promoPriceInfo && autoAppliedPromoCode && promoPriceInfo[autoAppliedPromoCode];
  }

  getPrice = () => {
    const {customerId} = this.props;
    const {"productDescriptor": {"details": {"retail_price": retailPrice}}} = this.props;

    if (customerId) {
      return this.getMemberPrice();
    }
      return retailPrice;
  }

  getMemberPrice = () => {
    const {pdPrices, productDescriptor} = this.props;

  const {
      id,
      "details": {
        "insider_price_dollars": insiderPriceDollars,
        "insider_price_dollars_varB": insiderPriceDollarsVarB,
        "insider_price_dollars_varC": insiderPriceDollarsVarC
      }
    } = productDescriptor;

    const insiderPriceMap = new Map([
      [
        "member_discount_var_b",
        insiderPriceDollarsVarB
      ],
      [
        "member_discount_var_c",
        insiderPriceDollarsVarC
      ]
    ]);

    if (pdPrices[id]) {
      return pdPrices[id].member_price;
    } else if (MemberDiscountHelper.shouldSeeMemberDiscountVariant()) {
      const memberVariant = MemberDiscountHelper.getMemberDiscountVariant();

      if (!memberVariant) return "";
      return insiderPriceMap.get(memberVariant);
    }
    return insiderPriceDollars;
  }

  renderClearancePrice = () => {
    const {
      cookies,
      "productDescriptor": {"details": {"retail_price": retailPrice}}
    } = this.props;
    const {"clearance_price": promoClearancePrice, "discount_text": discountText} = this.getPromoPriceInfo() || {};
    const experimentVariant = cookies.get("item_level_promo_experiment_variant");

    if (promoClearancePrice && PromoPriceVariantHelper.shouldSeePromoPrice(experimentVariant)) {
      return PromoPriceVariantHelper.renderPromoPriceOnGrid(retailPrice, promoClearancePrice);
    }

    if (promoClearancePrice && discountText && PromoPriceVariantHelper.shouldSeePromoPriceAndDiscount(experimentVariant)) {
      return PromoPriceVariantHelper.renderPromoPriceAndDiscountOnGrid(retailPrice, promoClearancePrice, discountText);
    }

    return (
      <div className="price flex justify-center align-middle gap-2 py-0.5">
        <span className="strike">
          {`$${Helper.formatPriceCents(retailPrice)}`}
        </span>
        {" "}
        <span className="font-bold text-tangerine-100">
          {this.getClearancePrice()}
        </span>
      </div>
    );
  }

  renderRetailPrice = () => {
    const {customerId, cookies} = this.props;
    const {price, "discount_text": discountText} = this.getPromoPriceInfo() || {};
    const experimentVariant = cookies.get("item_level_promo_experiment_variant");

    if (price && PromoPriceVariantHelper.shouldSeePromoPrice(experimentVariant)) {
      return PromoPriceVariantHelper.renderPromoPriceOnGrid(this.getPrice(), price);
    }

    if (price && discountText && PromoPriceVariantHelper.shouldSeePromoPriceAndDiscount(experimentVariant)) {
      return PromoPriceVariantHelper.renderPromoPriceAndDiscountOnGrid(this.getPrice(), price, discountText);
    }

    return (
      <div className="styled_h6 price mtn mbn">
        {customerId ? "member " : ""}
        {this.getPrice()}
      </div>
    );
  }

  renderInnerContents = () => {
    const {
      previewSwapping,
      productDescriptor,
      showComingSoon,
      showClearancePrice,
      showProductName,
      showRetailPrice
    } = this.props;
    const {
      "details": {
        designer,
        "first_date_received": firstDateReceived,
        "group_name": groupName
      }
    } = productDescriptor;

    return (
      <div className="row">
        <div className="styled_h6 designer-name">
          {designer}
        </div>
        {showProductName &&
        <div className="styled_h6 ph8 style-name">
          {groupName}
        </div>}

        {showClearancePrice && this.renderClearancePrice()}

        {showRetailPrice && this.renderRetailPrice()}

        {productDescriptor.details.ring_size && previewSwapping &&
          <div className="styled_h6 ring-size mb0 mt0">
            Size:&nbsp;
            {productDescriptor.details.ring_size}
          </div>
        }
        {showComingSoon && firstDateReceived === null &&
        <div className="coming-soon color-primary mt0">
          Coming Soon!
        </div>}
      </div>
    );
  }

  getUrl = (url) => {
    const urlObj = new URL(url);
    urlObj.search = "";

    return urlObj.toString();
  }

  getAllRingSizes = (availableRingSizes) => {
    const {allRingSizes} = this.props;
    const sizes = [
      ...new Set([
        ...allRingSizes,
        ...availableRingSizes
      ])
    ];

    return sizes.sort((valueA, valueB) => valueA - valueB);
  }

  renderPreviewImage = (previewSwatchId) => {
    const {availableSwatches} = this.state;
    const swatchId = availableSwatches.find(swatch => swatch.swatch_id === previewSwatchId);
    const swatchImage = swatchId && swatchId.available.length ? swatchId.available[0].image : null;

    return (
      <div className={`${swatchImage ? "z-1 absolute top-0 left-0 w-full aspect-square h-auto" : "hidden"}`}>
        <img src={swatchImage} />
      </div>
    );
  }

  render () {
    const {
      addWishListRequest,
      customerId,
      eligibleForFineJewelry,
      handleShowSwapModal,
      isLoggedOutHomepage,
      previewSwapping,
      productDescriptor,
      productDescriptors,
      productPanelClass,
      removeWishListRequest,
      ringSizes,
      showClearancePrice,
      showTags,
      showWishlistStars,
      useModal,
      wishlisted
    } = this.props;
    const {
      availableSwatches,
      enableAddToCart,
      hoveredSwatchId,
      isRing,
      omitQuickView,
      selectedSwatchId,
      selectedRingSize,
      showQuickViewButton,
      showingRingSelection
    } = this.state;
    const {
      "details": {
        "is_fine": isFine,
        "kind_name": kindName,
        "insider_price_dollars": insiderPriceDollars,
        name,
        "ratings": {
          average,
          count
        } = {},
        tag,
        url,
        wishlistable
      },
      id, sku
    } = productDescriptor;
    const availableRingSizes = ringSizes.map(ring => ring.ring_size);
    const defaultRingSize = availableRingSizes.length === 1 ? availableRingSizes[0] : null;
    const defaultSwatchId = availableSwatches ? availableSwatches.find(swatch => swatch.available.find(item => item.id === id))?.swatch_id : null;
    const defaultProductDescriptorId = (!isRing && defaultSwatchId) || (isRing && defaultRingSize && defaultSwatchId) ? id : null;
    const previewSwatchId = hoveredSwatchId || selectedSwatchId;
    return (
      <div
        className={`col-xs-6 col-sm-4 pt0 ph0 pd-container ${productPanelClass}`}
        data-test={`pd-${productDescriptor.id}`}
        onMouseEnter={this.handleShowQuickViewButton}
        onMouseLeave={this.handleHideQuickViewButton}
        tabIndex="0"
      >
        {showingRingSelection && wishlistable && (!isFine || eligibleForFineJewelry) &&
        <div className="pd-container-contents ring-size-content">
          <RingSizeSelection
            customerId={customerId}
            hideRingSizeSelection={this.handleHideRingSizeWishList}
            ringSizes={ringSizes}
            updateWishListCallback={this.updateWishListRequests}
          />
        </div>}
        {!showingRingSelection &&
        <div className="pd-container-contents">
          <div className={`row${this.shouldDisplaySlider() ? " pd-slider-contain" : " pd_image_contain"}`}>
            {previewSwatchId && previewSwatchId !== defaultSwatchId &&
            this.renderPreviewImage(previewSwatchId)}
            {showTags && tag &&
            <div className={`left ribbon-text most-requested ${this.checkTag(tag)}`}>
              {tag}
            </div>}
            {showWishlistStars && wishlistable && (!isFine || eligibleForFineJewelry) &&
            <Star
              addWishListCallback={kindName === "Ring" && ringSizes[0] && ringSizes[0].ring_size !== "Adjustable"
                ? this.handleShowRingSizeWishList
                : addWishListRequest}
              customerId={customerId}
              id={id}
              price={insiderPriceDollars}
              removeWishListCallback={kindName === "Ring" && ringSizes[0] && ringSizes[0].ring_size !== "Adjustable"
                ? this.handleShowRingSizeWishList
                : removeWishListRequest}
              sku={sku}
              wishlisted={this.displayWishlistStar(kindName, wishlisted)}
            />}
            {useModal && showQuickViewButton && !isLoggedOutHomepage && !omitQuickView &&
            <span
              className="btn btn-secondary btn-small quick-view"
              onClick={this.showModal}
            >
              + Quick View
            </span>}
            <div>
              <ProductPanelImageOrCarousel
                handleShowSwapModal={handleShowSwapModal}
                isGrid
                isMobile={isMobile()}
                isSwapped={this.isSwapped}
                previewSwapping={previewSwapping}
                productDescriptor={productDescriptor}
                productDescriptors={productDescriptors}
                queryParamBuilder={ProductPanel.queryParamBuilder}
                showClearancePrice={showClearancePrice}
                showModal={this.showModal}
              />
            </div>
            {isMobile() && !isLoggedOutHomepage && !omitQuickView &&
              <div
                className="quick-view-mobile"
                onClick={this.showModal}
              />
            }
          </div>

          {isLoggedOutHomepage &&
          <a
            className="product-panel-link"
            href={url}
            title={name}
          >
            {this.renderInnerContents()}
          </a>}

          {!isLoggedOutHomepage &&
          <Link
            className="product-panel-link"
            onClick={this.handleClick}
            title={name}
            to={{
              "pathname": previewSwapping ? "" : url,
              "search": ProductPanel.queryParamBuilder(
                window.location.search,
                showClearancePrice ? "from_clearance=true" : ""
              ),
              "state": {"prevPath": window.location.pathname}
            }}
          >
            {this.renderInnerContents()}
          </Link>}

          {!isLoggedOutHomepage &&
          <ProductRating
            average={average}
            count={count}
            forGrid
            previewSwapping
          />}

          {!isLoggedOutHomepage && !previewSwapping && enableAddToCart &&
          <AddToCart
            allRingSizes={this.getAllRingSizes(availableRingSizes)}
            availableRingSizes={availableRingSizes}
            defaultProductDescriptorId={defaultProductDescriptorId}
            defaultRingSize={defaultRingSize}
            defaultSwatchId={defaultSwatchId}
            isRing={isRing}
            selectedRingSize={selectedRingSize || defaultRingSize}
            selectedSwatchId={selectedSwatchId || defaultSwatchId}
            setHoveredSwatchId={this.setHoveredSwatchId}
            setNotificationType={this.setNotificationType}
            setSelectedRingSize={this.setSelectedRingSize}
            setSelectedSwatchId={this.setSelectedSwatchId}
            showClearancePrice={showClearancePrice}
            swatches={availableSwatches}
          />}

          {previewSwapping &&
            <SwapButton
              classes="btn-secondary centered swap-button btn-small"
              onSwap={handleShowSwapModal}
              productDescriptor={productDescriptor}
              productDescriptors={productDescriptors}
              text="Swap"
            />
          }
        </div>}
      </div>
    );
  }
}

const mapStoreToProps = store =>
  ({
    "customerRequests": store.customerRequests,
    "isLoggedOutHomepage": store.isLoggedOutHomepage,
    "pdPrices": store.pdPrices
  });

export default withCookies(connect(mapStoreToProps)(ProductPanel));
